import React from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { DIRECTION_COLORS, directionKey, directionKind, directionLabel, directionLimitsText } from "./ModeContrastGroups";

/**
 * One row per category of the Mode Contrast Filter: what it asks for and
 * what it selected. ``directions`` is the API's per-category result (the
 * filter page's live result or the overview's read-back). Used above the
 * pair map, so the reader sees the four results before the plot.
 */
export default function ModeContrastResultTable({ directions }) {
    return (
        <Table size="small" aria-label="Result per category" data-testid="mode-contrast-result-table">
            <TableHead>
                <TableRow>
                    <TableCell>Category</TableCell>
                    <TableCell>ΔE00 limits</TableCell>
                    <TableCell align="right">Within the limits</TableCell>
                    <TableCell align="right">Selected</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {directions.map((d) => {
                    const key = directionKey(d);
                    const stable = directionKind(d) === "stable";
                    const off = d.count === 0;
                    const within = stable
                        ? `${d.candidate_samples ?? 0} samples`
                        : `${d.candidate_pairs ?? 0} pairs · ${d.samples_with_partner ?? 0} samples`;
                    const selected = off
                        ? "off"
                        : stable
                            ? `${d.selected} of ${d.count} samples`
                            : `${d.groups.length} of ${d.count} pairs · ${d.selected} samples`;
                    return (
                        <TableRow key={key} data-testid={`mode-contrast-result-${key}`} sx={{ opacity: off ? 0.6 : 1 }}>
                            <TableCell>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Box sx={{ width: 10, height: 10, borderRadius: "50%", bgcolor: DIRECTION_COLORS[key], flexShrink: 0 }} />
                                    <Typography variant="body2" fontWeight={600}>{directionLabel(d)}</Typography>
                                </Box>
                            </TableCell>
                            <TableCell>
                                <Typography variant="body2" color="text.secondary">{directionLimitsText(d)}</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography variant="body2" color="text.secondary">{within}</Typography>
                            </TableCell>
                            <TableCell align="right">
                                <Typography variant="body2" fontWeight={off ? 400 : 700} color={off ? "text.secondary" : "text.primary"}>
                                    {selected}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
}
